export default {
    cn: {
        managerOperateRecord: {
            typeText: '操作类型：',
            operateDay: '操作日期：',
            downloadName: 'MT4经理操作记录',
            sheetNames: ['操作日志', '操作统计'],
            noData: {
                noRecordYesterday: '从MT4日志没有找到对应的经理操作记录',
                noLogFindInDB: 'MT4日志没有上传到数据库',
                noRecordFromMT4: '从MT4服务器日志中未发现记录(实时查询)',
                errorOccurred: '从MT4获取日志时发生问题(实时查询)'
            },
            operateTypeMapping: {
                "-1": "所有",
                "1": "重开交易单",
                "2": "删除交易单",
                "3": "更改开仓价格",
                // 4: "更改平仓价格",
                "5": "更改平仓信息",
                "6": "修复余额",
                "7": "更改出入金金额",
                "8": "更改交易单类型",
                "9": "帮客户平仓",
                "10": "帮客户建仓",
                "999": "其他(更改账号/更新等)",
            },
            summaryHead: [
                { key: 'operate_by', value: '操作人' },
                { key: 'operate_name', value: '操作人名称' },
                { key: '1', value: '重开交易单' },
                { key: '2', value: '删除交易单' },
                { key: '3', value: '更改开仓价格' },
                { key: '5', value: '更改平仓信息' },
                { key: '6', value: '修复余额' },
                { key: '7', value: '更改出入金金额' },
                { key: '8', value: '更改交易单类型' },
                { key: '9', value: '帮客户平仓' },
                { key: '10', value: '帮客户建仓' },
                { key: '999', value: '其他(更改账号/更新等)' },
            ],
            tableHead: [
                { key: 'operate_date', value: '操作时间' },
                { key: 'operate_by', value: '操作人' },
                { key: 'operate_name', value: '操作人名称' },
                { key: 'client', value: '客户账号' },
                { key: 'client_name', value: '客户名称' },
                { key: 'ticket', value: '交易单号' },
                { key: 'TYPE', value: '动作' },
                { key: 'old_cmd', value: '更改前指令' },
                { key: 'new_cmd', value: '更改后指令' },
                { key: 'old_volume', value: '更改前手数' },
                { key: 'new_volume', value: '更改后手数' },
                { key: 'old_symbol', value: '更改前产品' },
                { key: 'new_symbol', value: '更改后产品' },
                { key: 'old_op', value: '更改前开仓价' },
                { key: 'new_op', value: '更改后开仓价' },
                { key: 'old_cp', value: '更改前平仓价' },
                { key: 'new_cp', value: '更改后平仓价' },
                { key: 'old_profit', value: '更改前盈亏' },
                { key: 'new_profit', value: '更改后盈亏' },
            ],
        }
    },
    hk: {
        managerOperateRecord: {
            typeText: '操作類型：',
            operateDay: '操作日期：',
            downloadName: 'MT4經理操作記錄',
            sheetNames: ['操作日志', '操作統計'],
            noData: {
                noRecordYesterday: '從MT4日誌沒有找到對應的經理操作記錄',
                noLogFindInDB: 'MT4日誌沒有上傳到數據庫',
                noRecordFromMT4: '從MT4服務器日誌中未發現記錄(實時查詢)',
                errorOccurred: '從MT4獲取日誌時發生問題(實時查詢)'
            },
            operateTypeMapping: {
                "-1": "所有",
                "1": "重開交易單",
                "2": "刪除交易單",
                "3": "更改開倉價格",
                // 4: "更改平仓价格",
                "5": "更改平倉单信息",
                "6": "修復餘額",
                "7": "更改出入金金額",
                "8": "更改交易单类型",
                "9": "幫客戶平倉",
                "10": "幫客戶建倉",
                "999": "其他(更改帳號/更新等)",
            },
            summaryHead: [
                { key: 'operate_by', value: '操作人' },
                { key: 'operate_name', value: '操作人名稱' },
                { key: '1', value: '重開交易單' },
                { key: '2', value: '刪除交易單' },
                { key: '3', value: '更改開倉價格' },
                { key: '5', value: '更改平倉单信息' },
                { key: '6', value: '修復餘額' },
                { key: '7', value: '更改出入金金額' },
                { key: '8', value: '更改交易单类型' },
                { key: '9', value: '幫客戶平倉' },
                { key: '10', value: '幫客戶建倉' },
                { key: '999', value: '其他(更改帳號/更新等)' },
            ],
            tableHead: [
                { key: 'operate_date', value: '操作時間' },
                { key: 'operate_by', value: '操作人' },
                { key: 'operate_name', value: '操作人名稱' },
                { key: 'client', value: '客戶賬號' },
                { key: 'client_name', value: '客戶名稱' },
                { key: 'ticket', value: '交易單號' },
                { key: 'TYPE', value: '動作' },
                { key: 'old_cmd', value: '更改前指令' },
                { key: 'new_cmd', value: '更改后指令' },
                { key: 'old_volume', value: '更改前手數' },
                { key: 'new_volume', value: '更改后手數' },
                { key: 'old_symbol', value: '更改前產品' },
                { key: 'new_symbol', value: '更改后產品' },
                { key: 'old_op', value: '更改前開倉價' },
                { key: 'new_op', value: '更改后開倉價' },
                { key: 'old_cp', value: '更改前平倉價' },
                { key: 'new_cp', value: '更改后平倉價' },
                { key: 'old_profit', value: '更改前盈虧' },
                { key: 'new_profit', value: '更改后盈虧' },
            ]
        }
    },
    en: {
        managerOperateRecord: {
            typeText: 'Operate Type：',
            operateDay: 'Operate Day：',
            downloadName: 'MT4 Manager Operate Record',
            sheetNames: ['Operate Log', 'Operate statistics'],
            noData: {
                noRecordYesterday: 'No corresponding manager operation record found from MT4 logs',
                noLogFindInDB: 'MT4 logs not upload to mysql database',
                noRecordFromMT4: 'No records found from MT4 server logs (real-time query)',
                errorOccurred: 'A problem occurred while getting logs from MT4 (real-time query)'
            },
            operateTypeMapping: {
                "-1": "所有",
                "1": "Reopen Order",
                "2": "Delete Order",
                "3": "Update Open Order Open Price",
                // 4: "更改平仓价格",
                "5": "Update Closed Order",
                "6": "Fix Balance",
                "7": "Update Balance Amount",
                "8": "Change Order Cmd",
                "9": "Close Order By Manager",
                "10": "Open Order By Manager",
                "999": "Other",
            },
            summaryHead: [
                { key: 'operate_by', value: 'Manager Account' },
                { key: 'operate_name', value: 'Manager Name' },
                { key: '1', value: 'Reopen Order' },
                { key: '2', value: 'Delete Order' },
                { key: '3', value: 'Update Open Order Open Price' },
                { key: '5', value: 'Update Closed Order' },
                { key: '6', value: 'Fix Balance' },
                { key: '7', value: 'Update Balance Amount' },
                { key: '8', value: 'Change Order Cmd' },
                { key: '9', value: 'Close Order By Manager' },
                { key: '10', value: 'Open Order By Manager' },
                { key: '999', value: 'Other' },
            ],
            tableHead: [
                { key: 'operate_date', value: 'Time' },
                { key: 'operate_by', value: 'Manager Account' },
                { key: 'operate_name', value: 'Manager Name' },
                { key: 'client', value: 'Login' },
                { key: 'client_name', value: 'Name' },
                { key: 'ticket', value: 'Ticket' },
                { key: 'TYPE', value: 'Action' },
                { key: 'old_cmd', value: 'Old Cmd' },
                { key: 'new_cmd', value: 'New Cmd' },
                { key: 'old_volume', value: 'Old Volume' },
                { key: 'new_volume', value: 'New Volume' },
                { key: 'old_symbol', value: 'Old Symbol' },
                { key: 'new_symbol', value: 'New Symbol' },
                { key: 'old_op', value: 'Old Open Price' },
                { key: 'new_op', value: 'New Open Price' },
                { key: 'old_cp', value: 'Old Close Price' },
                { key: 'new_cp', value: 'New Close Price' },
                { key: 'old_profit', value: 'Old Profit' },
                { key: 'new_profit', value: 'New Profit' },
            ]
        }
    }
}


// WEBPACK FOOTER //
// ./src/language/record/managerOperateRecord.js